import { Component, Inject, OnInit, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';
import { AuthComprasService } from 'src/app/service/auth-compras.service';
import { ConsultaService } from 'src/app/service/consulta.service';
import { DialogComponent } from '../dialog/dialog.component';

@Component({
  selector: 'app-dialog-acessa-compra',
  templateUrl: './dialog-acessa-compra.component.html',
  styleUrls: ['./dialog-acessa-compra.component.scss']
})
export class DialogAcessaCompraComponent implements OnInit{
  public form!: FormGroup;

  public isLoading = signal<boolean>(false);

  constructor(
    public dialogRef: MatDialogRef<DialogAcessaCompraComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialog,
    private router: Router,
    private authService: AuthComprasService,
    private consultaService: ConsultaService,
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  public onLogin(login: {email: string, cpf: string}): void {
    this.isLoading.set(true);

    if (this.form.invalid) {
      this.isLoading.set(false);
      this.form.markAllAsTouched();
      return alert('Formulário inválido');
    }

    const credentials = { email: login.email, cpf: login.cpf };

    this.consultaService.loginConsultaPedidosResponsavel(credentials)
      .pipe(
        finalize(() => {
          this.isLoading.set(false);
          this.dialogRef.close();
        })
      )
      .subscribe({
        next: response => {
          if (response.status) {
            this.authService.setLoginData(response.cpf, response.token);              
            this.router.navigateByUrl('/minhas-compras');
          } else {
            this.dialog.open(DialogComponent, { data: response.mensagem });
          }
        },
        error: (error) => {
          this.dialog.open(DialogComponent, { data: 'Ocorreu um erro ao tentar fazer login.' });
          console.error('Erro no login:', error.message);
        }
      });
  }

  public isInvalid(ctrlName: string): boolean | undefined {
    return this.form.get(ctrlName)?.invalid;
  }

  public mensagemDeErro(ctrlName: string): string {
    const field = this.form.get(ctrlName);

    if (field?.hasError('required')) {
      return 'Preencha o campo.';
    }

    if (ctrlName === 'cpf' && this.form.get('cpf')?.errors !== null) {
      return 'Digite um CPF válido.';
    }

    if (ctrlName === 'email' && this.form.get('email')?.errors !== null) {
      return 'Digite um e-mail válido.';
    }

    return '';
  }

  private initForm(): void {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      cpf: new FormControl('', [Validators.required, Validators.minLength(11), Validators.maxLength(14)]),
    });
  }
}
